import { DocumentsModule } from '@pages/CompanyProfile/components/CompanyProfileModules/DocumentsModule';
import { getDocumentIcon } from '@pages/CompanyProfile/components/CompanyProfileTabs/DocumentsTab/getDocumentIcon';
import { DealDocumentsData } from '@services/requests/dealPageService/types/documentsData';
import React from 'react';

import { DocumentsTabStyledContainer } from './StyledComponents';

interface DocumentsTabProps {
  documentsData: DealDocumentsData;
  isAllowEdit: boolean;
}

function DocumentsTab({ documentsData, isAllowEdit }: DocumentsTabProps) {
  return (
    <DocumentsTabStyledContainer>
      {Object.values(documentsData.sections).map((section) => (
        <DocumentsModule
          key={section.code}
          Icon={getDocumentIcon(section.code)}
          title={section.caption}
          documents={section.fields}
          editText={documentsData.messages.btn_add}
          uploadText={documentsData.messages.btn_add}
          isAllowEdit={isAllowEdit}
          isArrayDocuments={true}
          serviceType="deal-page"
        />
      ))}
    </DocumentsTabStyledContainer>
  );
}

export { DocumentsTab };
